import { render } from "./PortfolioDetails.vue?vue&type=template&id=4eceb9bb&scoped=true"
import script from "./PortfolioDetails.vue?vue&type=script&lang=js"
export * from "./PortfolioDetails.vue?vue&type=script&lang=js"

import "./PortfolioDetails.vue?vue&type=style&index=0&id=4eceb9bb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4eceb9bb"

export default script